export default __webpack_public_path__ + "static/media/step_challenge-sheet.56eb0341.webp";